require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./posts-headless-cms-business-context.json") })
        }
      }, "path---posts-headless-cms-business-context");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---posts-headless-cms-business-context!./.cache/json/posts-headless-cms-business-context.json
// module id = 365
// module chunks = 231608221292675